var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardiology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M10.179,7.237l-1.7,2.5c0,0,1.5,1.1,0.1,4.2 s-0.7,6.2,1.1,9c0,0,4,5.7,9.9,4.8c0,0,3.6-0.6,3.4-8.7c0,0,0.3-8.4-6.1-9.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M11.874,13.433c0,0-2.795-2.396-0.895-5.696 l-1.3-1l0.8-1.3l1.3,1l0.8-0.8l-0.7-1.4l1.4-0.6l0.6,1.4h1.1l0.4-1.4l1.4,0.3l-0.5,1.5c0,0,0.4,0.2,0.6,0.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "4.379,20.837 8.779,20.837  10.679,17.637 12.579,23.037 13.779,20.937 18.079,20.937 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.687,
    y: 21.342,
    transform: "matrix(0.8124 -0.5831 0.5831 0.8124 -9.333 17.3765)",
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 1.3,
    height: 3.7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 20.179,
    cy: 20.037,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 20.179,
    cy: 20.037,
    r: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M21.879,24.137l3.3,4.6 c0.3,0.4,0.9,0.5,1.3,0.2c0.4-0.3,0.5-0.9,0.2-1.3l-3.3-4.6L21.879,24.137z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2C355E"
    },
    points: "21.879,19.337 20.879,19.337 20.879,18.337 19.479,18.337 19.479,19.337 18.479,19.337  18.479,20.737 19.479,20.737 19.479,21.737 20.879,21.737 20.879,20.737 21.879,20.737 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M9.647,14.392c0,0,2.416,0.343,2.771-2.25 c0,0,0.71-6.158,6.371-6.205c0,0,1.421-0.024,2.842,0.805l-1.16,3.008c0,0-1.918-1.066-3.466,0.055 c-1.547,1.121-1.532,4.674,0.237,6.126"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiology);
export default __webpack_public_path__ + "static/media/cardiology.b2d4530d62435dedeb5c4bfb02f4ed55.svg";
export { ForwardRef as ReactComponent };